import React from 'react'
import Media from 'sb-media'
import { FormattedMessage } from 'sb-react-intl'

import ActionButtons from '../ActionButtons/ActionButtons'

import messages from './messages'
import s from './Helpful.scss'


const Helpful = (props) => {
  const {
    id,
    isUseful, likeCount, dislikeCount,
    isReplyFormShown, isReplyButtonVisible, isHelpfulButtonsActive,
    onVote, onReplyFormToggle,
    dataTestIds,
  } = props

  return (
    <div className={s.helpful}>
      <div className={s.helpfulText}>
        <Media mobile>
          {
            (isMobile) => (
              <FormattedMessage {...isMobile ? messages.helpful : messages.helpfulLong} />
            )
          }
        </Media>
      </div>
      <ActionButtons
        id={id}
        isUseful={isUseful}
        likeCount={likeCount}
        dislikeCount={dislikeCount}
        onVote={onVote}
        onReplyFormToggle={onReplyFormToggle}
        replyButtonActive={isReplyFormShown}
        isReplyButtonVisible={isReplyButtonVisible}
        isHelpfulButtonsActive={isHelpfulButtonsActive}
        dataTestIds={dataTestIds}
      />
    </div>
  )
}


export default Helpful
